// extracted by mini-css-extract-plugin
module.exports = {"frame":"App_frame__3mVV6","frameMobile":"App_frameMobile__1dI0Z"};